import { App } from '../App';
import { Node } from '../Node';
import { EventEmitter } from '../core/EventEmitter';
import { Group, Layer } from '../shapes/Group';
import { Rect, Circle, Ellipse, Line, Arc, Polygon, Polyline, Path, Star, RoundedRect, TextNode, ImageNode, Sprite, } from '../shapes/index';
import { Camera } from '../camera/Camera';
import { CanvasRenderer } from '../renderers/CanvasRenderer';
import { Renderer } from '../renderers/Renderer';
import { registerRenderer } from '../registry/renderers';
import { animate, AnimationEngine } from '../animation/Animation';
import { Timeline, parallel } from '../animation/Timeline';
import { easings, getEasing, registerEasing } from '../animation/Easing';
import { Layout } from '../layout/index';
import { fromJSON, toJSON, registerJSONType, compactSceneJSON } from '../io/json';
import { exportScene, exportApp, downloadExport, validateSceneJSON, parseAndValidateSceneJSON, formatJsonParseError, locateJsonError, formatValidationErrors, validateThemePack, listKnownSceneTypes, formatExpectedValues, formatInvalidValue, suggestClosest, scenesEqual, } from '../io/export';
import { installPlugin, createPluginContext, getInstalledPlugins } from '../plugins/index';
import { Matrix2D, ObjectPool, detectBestRenderer } from '../utils';
export var VERSION = '1.2.1';
registerRenderer('canvas', function () { return new CanvasRenderer(); });
function use(plugin) {
    installPlugin(plugin, LightDraw);
}
function createApp(container, options) {
    return new App(container, options);
}
export var LightDraw = {
    version: VERSION,
    use: use,
    createApp: createApp,
    App: App,
    Node: Node,
    Group: Group,
    Layer: Layer,
    Rect: Rect,
    Circle: Circle,
    Ellipse: Ellipse,
    Line: Line,
    Arc: Arc,
    Polygon: Polygon,
    Polyline: Polyline,
    Path: Path,
    Star: Star,
    RoundedRect: RoundedRect,
    Text: TextNode,
    Image: ImageNode,
    Sprite: Sprite,
    Camera: Camera,
    CanvasRenderer: CanvasRenderer,
    Renderer: Renderer,
    animate: animate,
    AnimationEngine: AnimationEngine,
    Timeline: Timeline,
    parallel: parallel,
    easings: easings,
    getEasing: getEasing,
    registerEasing: registerEasing,
    Layout: Layout,
    fromJSON: fromJSON,
    toJSON: toJSON,
    compactSceneJSON: compactSceneJSON,
    registerJSONType: registerJSONType,
    exportScene: exportScene,
    exportApp: exportApp,
    downloadExport: downloadExport,
    validateSceneJSON: validateSceneJSON,
    parseAndValidateSceneJSON: parseAndValidateSceneJSON,
    formatJsonParseError: formatJsonParseError,
    locateJsonError: locateJsonError,
    formatValidationErrors: formatValidationErrors,
    validateThemePack: validateThemePack,
    listKnownSceneTypes: listKnownSceneTypes,
    formatExpectedValues: formatExpectedValues,
    formatInvalidValue: formatInvalidValue,
    suggestClosest: suggestClosest,
    scenesEqual: scenesEqual,
    createPluginContext: createPluginContext,
    getInstalledPlugins: getInstalledPlugins,
    Matrix2D: Matrix2D,
    ObjectPool: ObjectPool,
    detectBestRenderer: detectBestRenderer,
    EventEmitter: EventEmitter,
};
export { App, Node, Group, Layer, Rect, Circle, Ellipse, Line, Arc, Polygon, Polyline, Path, Star, RoundedRect, TextNode, ImageNode, Sprite, Camera, CanvasRenderer, Renderer, animate, AnimationEngine, Timeline, parallel, easings, getEasing, registerEasing, Layout, fromJSON, toJSON, compactSceneJSON, registerJSONType, exportScene, exportApp, downloadExport, validateSceneJSON, parseAndValidateSceneJSON, formatJsonParseError, locateJsonError, formatValidationErrors, validateThemePack, listKnownSceneTypes, formatExpectedValues, formatInvalidValue, suggestClosest, scenesEqual, createPluginContext, getInstalledPlugins, Matrix2D, ObjectPool, detectBestRenderer, EventEmitter, use, createApp, };
export default LightDraw;
if (typeof window !== 'undefined') {
    window.LightDraw = LightDraw;
}
